module.exports = __webpack_public_path__ + "static/media/left_bg.1ac5689a.png";